import React, { Component } from 'react';
import { Form, Field } from 'redux-form';
import PropTypes from 'prop-types';
import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import Button from '@material-ui/core/Button';
import { withStyles } from '@material-ui/core';
import FormLabel from '@material-ui/core/FormLabel';
import Typography from '@material-ui/core/Typography';


import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Card from '@material-ui/core/Card';
import CardMedia from '@material-ui/core/CardMedia';
import CardActionArea from '@material-ui/core/CardActionArea';

import SnackbarContent from '@material-ui/core/SnackbarContent';
import ErrorIcon from '@material-ui/icons/Error';
import LocationOn from '@material-ui/icons/LocationOn';
import VerifiedUser from '@material-ui/icons/VerifiedUser';
import { SERVER_ADDR, USER_FILES_FOLDER } from '../../constants';

const styles = theme => ({
  paper: {
    marginTop: theme.spacing.unit * 2,
    marginBottom: theme.spacing.unit * 2,
    display: 'flex',
    padding: `${theme.spacing.unit * 2}px ${theme.spacing.unit * 3}px ${theme.spacing.unit * 3}px`,
    flexGrow: 1,
  },
  userTypeBtn: {
    backgroundColor: '#3f51b5',
    padding: 2,
    maxWidth: 200,
    color: '#fff',
    display: 'inline-block'
  },
  media: {
    height: 140,
  },
});

class UserDetails extends Component {
  static propTypes = {
    classes: PropTypes.object,
    user: PropTypes.object,
    formType: PropTypes.string,
    error: PropTypes.string
  };

  render() {
    const {
      classes,
      error,
      details,
      userType
    } = this.props;

    return (
      <React.Fragment>
        {
          (error !== undefined) &&
          <SnackbarContent
            className={classes.error}
            message={
              <span className={classes.message}>
                <ErrorIcon className={`${classes.icon} ${classes.iconVariant}`} />
                {error.toString()}
              </span>
            }
          />
        }

        <Paper className={classes.paper}>
          <Grid container spacing={24}>
            <Grid container spacing={24}>
              <Grid item xs={3} sm={3}>
                <Card>
                  <CardActionArea>
                    <CardMedia
                      className={classes.media}
                      image={`${SERVER_ADDR}public/assets/${USER_FILES_FOLDER}/${details.image}`}
                      title="Profile Pic"
                    />
                  </CardActionArea>
                </Card>
              </Grid>
              <Grid item xs={9} sm={9}>
                <p>
                  <Typography variant="h6">
                    {details.firstName} {details.lastName} { details.isVerified && <VerifiedUser fontSize="small" /> }
                  </Typography>

                  <Typography variant="caption">{details.email}</Typography>

                  <Typography variant="caption">
                    {details.phoneNumber}
                  </Typography>

                  <Typography variant="body2">
                    {details.Address} {details.city} {details.state} {details.country} {details.zip} <LocationOn />
                  </Typography>

                  <div className={classes.userTypeBtn}>
                    {userType}
                  </div>
                </p>

              </Grid>
            </Grid>

          </Grid>
        </Paper>
      </React.Fragment>
    );
  }
}

export default withStyles(styles)(UserDetails);